/**
 * @author Ivan Toth.
 * contains edit, cancel, save buttons, that are running the bound functions of their parents
 */
var FlagController = (function () {
    function FlagController(topic, env) {
        this.topic = topic;
        this.env = env;
        this.comp = 'header_data';
        this.updateArray = ['header_data'];
    }
    FlagController.prototype.$onInit = function () {
        this.hovered = false;
        this.edit = this.topic.getEditComponent(this.comp);
    };
    FlagController.prototype.flagChange = function (newStat) {
        if (this.topic.getEditComponent(this.comp)) {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.temp.header_data.flag = newStat;
                this.topic.sendForUpdateGeneral(this.updateArray, false);
            }
        }
    };
    FlagController.prototype.sendComment = function () {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            this.hovered = false;
            this.topic.temp.header_data.comment = this.comment;
            this.topic.sendForUpdateGeneral(this.updateArray, false);
        }
    };
    FlagController.prototype.enableComment = function () {
        this.hovered = true;
        this.comment = this.topic.temp.header_data.comment;
    };
    FlagController.$inject = ['topic', 'env'];
    return FlagController;
}());
var FlagComponent = (function () {
    function FlagComponent() {
        this.templateUrl = 'flag.html';
        this.controllerAs = 'vm';
        this.controller = FlagController;
    }
    return FlagComponent;
}());
angular
    .module('application')
    .component('flagSection', new FlagComponent());

//# sourceMappingURL=detail.flag.component.js.map
